import { Options } from 'react-use-websocket'

export const DEFAULT_WEBSOCKET_CONFIG: Options = {
  reconnectAttempts: 10,
  reconnectInterval: 5 * 1000,
  shouldReconnect: () => true,
  retryOnError: true,
  share: true,
}
